<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (change)="filterChange.emit(filter)">
    <option value="in">est</option>
  </select>

  <div class="ml-2">
    <select [(ngModel)]="filter.tempValue" class="form-control max-width-240px" (ngModelChange)="filterChange.emit(filter)">
      <option [value]="[InvoiceStatus.PAID]" jhiTranslate="filters.payment-status.PAID"></option>
      <option [value]="[InvoiceStatus.ACCEPTED]" jhiTranslate="filters.payment-status.ACCEPTED"></option>
      <option [value]="[InvoiceStatus.INIT]" jhiTranslate="filters.payment-status.INIT"></option>
      <option [value]="[InvoiceStatus.BILLED]" jhiTranslate="filters.payment-status.BILLED"></option>
      <option [value]="[InvoiceStatus.CANCELED]" jhiTranslate="filters.payment-status.CANCELED"></option>
      <option [value]="[InvoiceStatus.ISSUED]" jhiTranslate="filters.payment-status.ISSUED"></option>
      <option [value]="[InvoiceStatus.OFFLINE]" jhiTranslate="filters.payment-status.OFFLINE"></option>
      <option [value]="[InvoiceStatus.LATE]" jhiTranslate="filters.payment-status.LATE"></option>
    </select>
  </div>
</div>
